import { render, staticRenderFns } from "./QrcodeDialog.vue?vue&type=template&id=4bb31814&scoped=true"
import script from "./QrcodeDialog.vue?vue&type=script&lang=js"
export * from "./QrcodeDialog.vue?vue&type=script&lang=js"
import style0 from "./QrcodeDialog.vue?vue&type=style&index=0&id=4bb31814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb31814",
  null
  
)

export default component.exports